// extracted by mini-css-extract-plugin
module.exports = {"label":"check-box_label__TeWz6","input":"check-box_input__3klYF","icon":"check-box_icon__3xAHS"};